<script>
    import { Navigate } from "svelte-router-spa";
    import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
    import Icon from "svelte-awesome";
    import { AlumnoDTO } from "../api/DTOS/Alumno.dto.js";
    import { CarreraDTO } from "../api/DTOS/Carrera.dto.js";
    import { carrerasBasicas } from "../MainStore.js";

    export let currentRoute;
    export let params;
    
    let currentPath = currentRoute.name.replace("/index", "");
    let alumno = new AlumnoDTO();
    let carreraSeleccionada = new CarreraDTO();

    const handleChangeCarreraSeleccionada = (idCarrera) => {

    }
</script>

<div class="row">
    <div class="col-md-2">
        <Navigate to="/alumnos">
            <Icon data={faArrowLeft} />
        </Navigate>
    </div>
</div>
<div class="card mt-2">
    <div class="card-header">
        <div class="row">
            <div class="col-4 my-auto">
                {alumno.apellidos} {alumno.nombres}
            </div>
            <div class="col text-right">
                <div class="row justify-content-end">
                    <div class="col my-auto">
                        <div class="btn-group">
                            <button class="btn dropdown-toggle text-right" data-toggle="dropdown">
                                {carreraSeleccionada.nombre === "" ? "Carrera" : carreraSeleccionada.nombre}
                            </button>
                            <div class="dropdown-menu">
                                {#each $carrerasBasicas as carrera}
                                    <button class="dropdown-item" onClick={() => { handleChangeCarreraSeleccionada(carreraSeleccionada.id) }}>{carrera.nombre}</button>
                                {/each}
                            </div>
                        </div>
                    </div>
                    <div class="col-4 my-auto">
                        <Navigate to={`${currentPath}/agregarcarrera`}>
                            <button class="btn btn-raised btn-success" >Agregar carrera</button>
                        </Navigate>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div id="accordion">
            <div class="card">
                <div class="card-header" id="encabezadoDatosPersonales" data-toggle="collapse" data-target="#datosPersonalesCollapse">
                    <span>
                        Datos personales
                    </span>
                </div>
                <div id="datosPersonalesCollapse" class="collapse" data-parent="#accordion">
                    <div class="card-body" />
                </div>
            </div>
            <div class="card">
                <div class="card-header" id="encabezadoMaterias" data-toggle="collapse" data-target="#materiasCollapse">
                    <span>
                        Materias
                    </span>
                </div>
                <div id="materiasCollapse" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Año</th>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col">Libro/Folio</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">3</th>
                                    <td>HISTORIA Y PROSPECTIVA DE LA EDUCACIÓN</td>
                                    <td>Matriculado</td>
                                    <td>10/326</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" id="encabezadoHistorial" data-toggle="collapse" data-target="#historialCollapse">
                    <span>
                        Historial
                    </span>
                </div>
                <div id="historialCollapse" class="collapse" data-parent="#accordion">
                    <div class="card-body">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab">2015</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab">2016</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab">2017</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab">2018</a>
                            </li>
                        </ul>
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active" id="pills-home" role="tabpanel">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Nombre</th>
                                            <th scope="col">Año</th>
                                            <th scope="col">Nota</th>
                                            <th scope="col">Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row">HISTORIA Y PROSPECTIVA DE LA EDUCACIÓN</th>
                                            <td>2015</td>
                                            <td>Aprobado</td>
                                            <td>Cursado</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="tab-pane fade" id="pills-profile" role="tabpanel">...</div>
                            <div class="tab-pane fade" id="pills-contact" role="tabpanel">...</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>